import * as React from "react";
import Tooltip from '@mui/material/Tooltip';
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import CancelIcon from '@mui/icons-material/Cancel';
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import GavelIcon from '@mui/icons-material/Gavel';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import IconButton from "@mui/material/IconButton";
import DescriptionIcon from '@mui/icons-material/Description';
import Typography from "@mui/material/Typography";
import Header from '../Includes/Header';
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { useEffect, useRef } from "react";
import { DialogContentText } from '@mui/material';
import { Card, Button, Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Paper, Avatar } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Menu from '@mui/material/Menu';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';

import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import CircularProgress from "@mui/material/CircularProgress";
import dayjs from 'dayjs';
import json2mq from "json2mq";
import {
  retrieveEmployeesDetails,
  DeleteEmployeesDetails,
  AutocompleteEmployeesDetails,
  UpdateEmployees
} from "../Apihelper/ApiEmployeesDetails";

import {
 
  AutocompleteAdminUser,
  DeleteAdminUser,
  StatusAdminUser,
  UpdateAdminUser
} from "../Apihelper/ApiHelperUser";


import { useNavigate } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';
import DeviceEnrollDialog from '../../components/DeviceEnroll/DeviceEnrollDialog';

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;

// Add theme constants
const buildThemeColors = (appColors) => ({
  primary:      appColors.leaf,
  primaryLight: appColors.leaf,
  background:   '#F6F5F0',
  surface:      '#FFFFFF',
  text:         '#1B2420',
  textSecondary:'#5B6660',
  border:       '#E6E4DC',
});

function EmployeesDetail(props) {
  const { colors: appColors } = useAppTheme();
  const themeColors = buildThemeColors(appColors);
  const navigate = useNavigate();
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [status, setstatus] = useState('');
  const [openConfirmation, setOpenConfirmation] = useState(false);
const [isActive, setIsActive] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [Role, setRole] = useState('');
  const [openToast, setOpenToast] = useState(false);
  const [options, setOptions] = useState([]);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // Default to 'success'
  const [fetchdatarow, setetchdatarow] = useState([]); // Default to 'success'
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [localrole] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userdata"))?.role || "";
    } catch {
      return "";
    }
  });
  const dateRef = useRef();
  const [age, setAge] = React.useState('');
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [bioOpen, setBioOpen] = useState(false);
  const [editImagePreview, setEditImagePreview] = useState(null);
  const editFileInputRef = React.useRef(null);

  const handleEditImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setEditedData((prev) => ({ ...prev, selectedFile: file }));
    setEditImagePreview(URL.createObjectURL(file));
  };

  const [editedData, setEditedData] = useState({
    id: '',
    address: '',
    fullname: '',
    email: '',
    phone: '',
    designation: '',
    salary:'',
    bloodgroup:'',
    joiningdate: new Date()
  });
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );

  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }

  const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  // useEffect(() => {
  //   // Perform localStorage action
  //   const item = localStorage.getItem('userdata')
  //   if (item ==null){
  //      setredirectpage(true);
  //   }
  //   //console.log("tapan"+item);
  // }, [])
  // if (redirectpage) {

  //   return redirect('/');
  // }


  const handleToggle = (id,status) => {
    setOpenConfirmation(true);
   const newStatus = status === 1 ? 0 : 1;
  setstatus(newStatus);
  setDeleteConfirmationId(id);
  setIsActive(newStatus === 0);

  };

  const handleConfirm = async() => {
    // setIsActive(!isActive);
    // setOpenConfirmation(false);

    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; 
     
      
        const res = await StatusAdminUser(userToken,userId,status, deleteConfirmationId);

        if (res.code == "200") {
            handleSnackbarOpen(res.message, 'success');
            setIsActive(!isActive);
            setOpenConfirmation(false);
            setOpenDeleteConfirmation(false);
            fetchData();
        } else {
            handleSnackbarOpen(res.message, 'error');
            //  console.error(error); // Handle error
        }
    } catch (error) {
        console.error(error);
        // Handle errors
    }
  };
  const handleCancel = () => {
    setOpenConfirmation(false);
  };
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const fetchData = async (value = '') => {
    setLoading(true);
    setHasMore(true);
    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; // Assuming you have a userId in userdata
        const searchText = value; // Example search text
        const limit = 10; // Example limit
        const index = 0; // Example index
        const res = await retrieveEmployeesDetails(userToken, userId, searchText, limit, index);

        if (res.code == "200") {
            setetchdatarow(res.data)
            console.log(res.data);
            setLoading(false);
        } else {
            // console.error(error); // Handle error
        }
    } catch (error) {
        console.error(error);
        // Handle errors
    }
};

  useEffect(() => {
   
    fetchData();
}, []); 


const handleLoadMore = async () => {
  // Calculate the next index based on the number of items loaded so far
  const nextIndex = fetchdatarow.length

  const userData = localStorage.getItem("userdata");
  const userDataObj = JSON.parse(userData);

  try {
    const userToken = userDataObj.token;
    const userId = userDataObj.id;
    const searchText = ''
    const limit = 10;

    const res = await retrieveEmployeesDetails(userToken, userId, searchText, limit, nextIndex);

    if (res.code == "200") {
      // Append the newly loaded data to the existing data
      setetchdatarow((prevResults) => [...prevResults, ...res.data]);

      // Check if there are more results available
      if (res.data.length >= 0 && res.data.length < 10) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    }
  } catch (error) {
    console.error("Error:", error);
  }
};


const handleSearchChange = (event, value) => {
  const searchText = value || ''; // If value is undefined or empty, set searchText to empty string
  // setSearchText(searchText);
  // Call fetchData function here with the updated searchText
  fetchData(searchText);
};

const handleDelete = (id) => {
  handleClose();
  setDeleteConfirmationId(id);
  setOpenDeleteConfirmation(true,id);
};

const handleConfirmDelete =async (id) => {
  // setSnackbarMessage('package deleted successfully');
  // setSnackbarSeverity('error');
  // setOpenDeleteConfirmation(false);
  // setOpenToast(true); // Show toast message

  if (deleteConfirmationId !== null) {
   
      try {
          const userData = localStorage.getItem("userdata");
          const userDataObj = JSON.parse(userData);
          const userToken = userDataObj.token;
          const userId = userDataObj.id; 
       
        
          const res = await DeleteEmployeesDetails(userToken, userId, deleteConfirmationId);

          setOpenDeleteConfirmation(false);
          if (res.code == "200") {
              handleSnackbarOpen(res.message, 'success');
              fetchData();
          } else {
              handleSnackbarOpen(res.message, 'error');
          }
      } catch (error) {
          console.error(error);
          // Handle errors
      }
  }
  };


const handleCancelDelete = () => {
  setOpenDeleteConfirmation(false);
};
const handleInputChange = async (value) => {
  if (value.length >= 3) {
  try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id; // Assuming you have a userId in userdata
      const searchText = value; // Example search text
    
      const res = await AutocompleteEmployeesDetails(userToken, userId, searchText);

      if (res.code == "200") {
          const names = res.data.map(item => item.search_data);
          setOptions(names);
      } else {
          handleSnackbarOpen(res.message, 'error');
          //  console.error(error); // Handle error
      }
  } catch (error) {
      console.error(error);
      // Handle errors
  }
}
};
const handleEditModalOpen = (id, fullname, email, phone, address, card_number, designation, salary, blood_group, joining_date, image, morning_slot, evening_slot, excuse_time) => {
  setEditedData({
    id,
    fullname,
    email,
    phone,
    address,
    card_number,
    designation,
    salary,
    bloodgroup: blood_group,
    joiningdate: dayjs(joining_date),
    selectedFile: null,
    morningSlot: morning_slot,
    eveningSlot: evening_slot,
    excuseTime: excuse_time,
  });
  setEditImagePreview((image && image !== 'null') ? image : null);
  setEditModalOpen(true);
};

const handleEditModalClose = () => {
  setEditModalOpen(false);
  setEditImagePreview(null);
};

const handlePasswordChange = (event) => {
  setPassword(event.target.value);
  // Reset confirm password error when password is changed
  setConfirmPasswordError('');
};

const handleConfirmPasswordChange = (event) => {
  setConfirmPassword(event.target.value);
  // Check if confirm password matches password
  if (event.target.value !== password) {
    setConfirmPasswordError('Passwords do not match');
  } else {
    setConfirmPasswordError('');
  }
};

const handleEditSubmit = async () => {
  if (password !== confirmPassword) {
    setConfirmPasswordError('Passwords do not match');
    return;
  }

  const userData = localStorage.getItem("userdata");
  const userDataObj = JSON.parse(userData);
  const userToken = userDataObj.token;

  try {
    const res = await UpdateEmployees(
      editedData.id, // Assuming id is needed for updating
      userToken,
      editedData, // Pass the entire editedData object
      confirmPassword // Pass confirmPassword separately
    );

    if (res.code == "200") {
      handleSnackbarOpen(res.message, 'success');
      setConfirmPassword('');
      setPassword('');
      setEditImagePreview(null);
      setEditedData({ id: '', address: '', fullname: '', email: '', phone: '', designation: '', salary: '', bloodgroup: '', joiningdate: null, selectedFile: null });
      fetchData();
    } else {
      handleSnackbarOpen(res.message, 'error');
    }
  } catch (error) {
    console.error(error);
  }

  setEditModalOpen(false);
};
useEffect(() => {
  const storedData = localStorage.getItem("userdata");
  if (!storedData) {
    // User is not logged in, no need to redirect
    navigate('/');
  }
  
}, []);
const handleRoleChange = (event) => {
  setRole(event.target.value);
};
const handleCreateOfferLetter = (employeeData) => {
  navigate('/offer-letter', { state: { employeeData } });
};
const handleGenerateAgreement = (employee) => {
  navigate('/employee-agreement', { state: { employeeData: employee } });
};
const handleEmailClick = (userId, userName) => {
  console.log(`User ID: ${userId}, User Name: ${userName}`);
  navigate(`/monthly-attendance?userId=${userId}&userName=${userName}`);
};

  return (
    <Box sx={{ display: 'flex', height: '100vh', backgroundColor: themeColors.background }}>
      <CssBaseline />
      <Box>
        <Header />
      </Box>
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          overflowY: 'auto', 
          padding: '24px',
          backgroundColor: themeColors.background
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', marginTop: '64px' }}>
          {/* Search + New Employee row (like Packages) */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Box sx={{ flex: 1 }}>
              <Autocomplete
                freeSolo
                id="employee-search"
                disableClearable
                options={options}
                onInputChange={(event, value) => handleInputChange(value)}
                onChange={(event, value) => handleSearchChange(event, value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    sx={{
                      maxWidth: { xs: '100%', sm: 300 },
                      background: 'rgba(255, 255, 255, 0.9)',
                      borderRadius: '8px',
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': { borderColor: appColors.leaf },
                        '&.Mui-focused fieldset': { borderColor: appColors.leaf }
                      }
                    }}
                    label="Search employees"
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                  />
                )}
              />
            </Box>
            <Box>
              {localrole === 'admin' && (
              <Button
                variant="contained"
                startIcon={<ControlPointIcon />}
                onClick={() => navigate('/addemployees')}
                sx={{
                  textTransform: 'none',
                  fontWeight: 700,
                  background: `linear-gradient(to right, ${appColors.evergreen}, ${appColors.leaf})`,
                  '&:hover': {
                    background: `linear-gradient(to right, ${appColors.pine}, #60a5fa)`,
                  },
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  px: 3
                }}
              >
                Add New
              </Button>
              )}
            </Box>
          </Box>

          {/* Table Section (like Packages table) */}
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
              borderRadius: '16px',
              overflowX: 'auto',
              background: '#ffffff',
              '@media (max-width: 600px)': { borderRadius: '12px' }
            }}
          >
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
                <CircularProgress sx={{ color: themeColors.primary }} />
              </Box>
            ) : (
              <Table size="medium" aria-label="employee table">
                <TableHead>
                  <TableRow sx={{ background: appColors.leaf }}>
                    {[
                      { label: "Name", hide: false },
                      { label: "Contact Info", hide: false },
                      { label: "Designation / Salary", hide: false },
                      { label: "Joining", hide: true },
                      { label: "B.Group", hide: true },
                      // { label: "Card", hide: true },
                      ...(localrole === 'admin' ? [{ label: "Action", hide: false }] : []),
                    ].map(({ label, hide }) => (
                      <TableCell
                        key={label}
                        align={label === "Action" ? "center" : "left"}
                        sx={{
                          color: '#ffffff',
                          fontWeight: 600,
                          fontSize: { xs: '0.8rem', sm: '1rem' },
                          py: 2,
                          px: { xs: 1, sm: 2 },
                          display: hide ? { xs: 'none', md: 'table-cell' } : 'table-cell',
                        }}
                      >
                        {label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
          <TableBody>
            {fetchdatarow.map((row, indexx) => (
              <TableRow
                key={indexx}
                sx={{
                  '&:nth-of-type(odd)': { backgroundColor: '#f8fafc' },
                  '&:hover': { backgroundColor: '#f1f5f9' },
                  transition: 'background-color 0.2s ease',
                }}
              >
                <TableCell sx={{ py: 2, '@media (max-width: 600px)': { px: 1 } }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Avatar
                      src={[row.image, row.emp_image, row.profile_image].find(v => v && v !== 'null') || ''}
                      alt={row.name}
                      sx={{
                        width: 40,
                        height: 40,
                        bgcolor: appColors.leaf,
                        fontSize: '1rem',
                        fontWeight: 700,
                        flexShrink: 0,
                        border: '2px solid #e2e8f0',
                      }}
                    >
                      {row.name?.[0]?.toUpperCase()}
                    </Avatar>
                    <Typography sx={{ fontWeight: 500, color: '#1e293b' }}>
                      {row.name}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell sx={{ py: 2, '@media (max-width: 600px)': { px: 1 } }}>
                  <Typography
                    sx={{
                      color: appColors.leaf,
                      cursor: 'pointer',
                      fontSize: '0.875rem',
                      '&:hover': { textDecoration: 'underline' }
                    }}
                    onClick={() => handleEmailClick(row.id, row.name)}
                  >
                    {row.email}
                  </Typography>
                  <Typography sx={{ color: '#475569', fontSize: '0.875rem' }}>
                    {row.phone}
                  </Typography>
                </TableCell>
                <TableCell sx={{ py: 2, '@media (max-width: 600px)': { px: 1 } }}>
                  <Typography sx={{ color: '#475569', fontWeight: 500 }}>{row.designation}</Typography>
                  {localrole === 'admin' && (
                    <Typography sx={{ color: '#64748b', fontSize: '0.875rem' }}>₹{row.salary}</Typography>
                  )}
                </TableCell>
                <TableCell sx={{ py: 2, px: { xs: 1, sm: 2 }, display: { xs: 'none', md: 'table-cell' } }}>
                  <Typography sx={{ color: '#475569' }}>{row.joining_date}</Typography>
                </TableCell>
                <TableCell sx={{ py: 2, px: { xs: 1, sm: 2 }, display: { xs: 'none', md: 'table-cell' } }}>
                  <Typography sx={{ color: '#475569' }}>{row.blood_group}</Typography>
                </TableCell>
                {/* <TableCell sx={{ py: 2, px: { xs: 1, sm: 2 }, display: { xs: 'none', md: 'table-cell' } }}>
                  <Typography sx={{ color: '#475569' }}>{row.card_number}</Typography>
                </TableCell> */}
                {localrole === 'admin' && (
                <TableCell align="center" sx={{ py: 2, '@media (max-width: 600px)': { px: 1 } }}>
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5, flexWrap: 'nowrap' }}>
                    <Tooltip title="Edit Employee">
                      <IconButton
                        size="small"
                        onClick={() => handleEditModalOpen(row.id, row.name, row.email, row.phone, row.address, row.card_number, row.designation, row.salary, row.blood_group, row.joining_date, row.image, row.morning_slot, row.evening_slot, row.excuse_time)}
                        sx={{ color: appColors.leaf, '&:hover': { backgroundColor: '#e2e8f0' } }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Employee">
                      <IconButton
                        size="small"
                        onClick={() => handleDelete(row.id)}
                        sx={{ color: '#ef4444', '&:hover': { backgroundColor: '#fee2e2' } }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Create Offer Letter">
                      <IconButton
                        size="small"
                        onClick={() => handleCreateOfferLetter(row)}
                        sx={{ color: appColors.leaf, '&:hover': { backgroundColor: '#e2e8f0' } }}
                      >
                        <DescriptionIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Generate Agreement">
                      <IconButton
                        size="small"
                        onClick={() => handleGenerateAgreement(row)}
                        sx={{ color: appColors.leaf, '&:hover': { backgroundColor: '#e2e8f0' } }}
                      >
                        <GavelIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
    <Box sx={{ textAlign: 'center', marginTop: 2 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleLoadMore}
        disabled={!hasMore || (fetchdatarow.length < 10 && fetchdatarow.length !== 0)}
        sx={{
          fontWeight: 'bold',
          textTransform: 'none',
          background: `linear-gradient(to right, ${appColors.evergreen}, ${appColors.leaf})`,
          '&:hover': { background: `linear-gradient(to right, ${appColors.pine}, #60a5fa)` }
        }}
      >
        {fetchdatarow.length === 0 || fetchdatarow.length < 10 ? 'No More Records' : 'Load More'}
      </Button>
    </Box>
      </div>
      </Box>
      <Dialog open={openDeleteConfirmation} onClose={handleCancelDelete} fullWidth="sm">
      
      <DialogTitle>Delete Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this package?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button startIcon={<CancelIcon />} sx={{fontWeight:'bold',textTransform:'none'}} onClick={handleCancelDelete}>Cancel</Button>
        <Button onClick={handleConfirmDelete}  sx={{fontWeight:'bold',textTransform:'none'}} variant="contained" startIcon={<DeleteIcon />} color="error"> Delete</Button>
      </DialogActions>
    </Dialog>
      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
      <Dialog open={openConfirmation} onClose={handleCancel}>
        <DialogTitle>{isActive ? 'Deactivate' : 'Activate'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isActive
              ? 'Are you sure you want to deactivate this item?'
              : 'Are you sure you want to activate this item?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button  sx={{fontWeight:'bold',textTransform:'none'}} startIcon={<CancelIcon />}onClick={handleCancel}>Cancel</Button>
          <Button onClick={handleConfirm}sx={{fontWeight:'bold',textTransform:'none'}} variant="contained"startIcon={<CheckCircleIcon />} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog 
        open={editModalOpen} 
        onClose={handleEditModalClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            backgroundColor: themeColors.surface,
            backgroundImage: 'none'
          }
        }}
      >
        <DialogTitle sx={{ 
          borderBottom: `1px solid ${themeColors.border}`,
          px: 3,
          py: 2,
          backgroundColor: themeColors.primary,
          color: themeColors.surface,
          fontSize: '1.25rem',
          fontWeight: 600
        }}>
          Edit Employee Details
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          {/* Profile Photo */}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3, gap: 1 }}>
            <input
              ref={editFileInputRef}
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleEditImageChange}
            />
            <Box
              onClick={() => editFileInputRef.current.click()}
              sx={{
                position: 'relative',
                cursor: 'pointer',
                borderRadius: '50%',
                display: 'inline-flex',
                '&:hover .cam-overlay': { opacity: 1 },
              }}
            >
              <Avatar
                src={editImagePreview}
                alt={editedData.fullname}
                sx={{
                  width: 90,
                  height: 90,
                  bgcolor: appColors.leaf,
                  fontSize: '2rem',
                  fontWeight: 700,
                  border: `3px solid ${appColors.evergreen}`,
                }}
              >
                {!editImagePreview && (editedData.fullname?.[0]?.toUpperCase() || '?')}
              </Avatar>
              <Box
                className="cam-overlay"
                sx={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: '50%',
                  bgcolor: 'rgba(31,122,84,0.55)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: 0,
                  transition: 'opacity 0.2s ease',
                }}
              >
                <CameraAltIcon sx={{ color: '#fff', fontSize: 24 }} />
              </Box>
            </Box>
            <Typography variant="caption" sx={{ color: themeColors.textSecondary }}>
              Click to change photo
            </Typography>
          </Box>

          <Grid container spacing={2.5}>
            {/* Personal Information Section */}
            <Grid  size={{ xs: 12}}>
              <Typography variant="subtitle1" sx={{
                color: themeColors.primary,
                fontWeight: 600,
                mb: 2
              }}>
                Personal Information
              </Typography>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12,sm:6}}>
            <TextField
                    fullWidth
              label="Name"
              value={editedData.fullname}
              onChange={(e) => setEditedData({ ...editedData, fullname: e.target.value.toUpperCase() })}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: themeColors.background,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12,sm:6}}>
            <TextField
                    fullWidth
                    label="Blood Group"
                    value={editedData.bloodgroup}
                    onChange={(e) => setEditedData({ ...editedData, bloodgroup: e.target.value.toUpperCase() })}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: themeColors.background,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        }
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Contact Information Section */}
            <Grid size={{ xs: 12}}>
              <Typography variant="subtitle1" sx={{ 
                color: themeColors.primary,
                fontWeight: 600,
                mb: 2 
              }}>
                Contact Information
              </Typography>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12,sm:6}}>
                  <TextField
                    fullWidth
              label="Email"
              type="email"
              value={editedData.email}
              onChange={(e) => setEditedData({ ...editedData, email: e.target.value })}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: themeColors.background,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12,sm:6}}>
            <TextField
                    fullWidth
              label="Phone"
              type="number"
              value={editedData.phone}
              onChange={(e) => setEditedData({ ...editedData, phone: e.target.value })}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: themeColors.background,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12}}>
            <TextField
                    fullWidth
              label="Address"
              value={editedData.address}
              onChange={(e) => setEditedData({ ...editedData, address: e.target.value.toUpperCase() })}
                    multiline
                    rows={2}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: themeColors.background,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        }
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Employment Information Section */}
            <Grid size={{ xs: 12}}>
              <Typography variant="subtitle1" sx={{ 
                color: themeColors.primary,
                fontWeight: 600,
                mb: 2 
              }}>
                Employment Information
              </Typography>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12,sm:6}}>
                  <FormControl 
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: themeColors.background,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        }
                      }
                    }}
                  >
                    <InputLabel>Designation</InputLabel>
            <Select
              value={editedData.designation}
                      label="Designation"
              onChange={(e) => setEditedData({ ...editedData, designation: e.target.value })}
            >
                <MenuItem value="">Select Designation</MenuItem>
              <MenuItem value="manager">Manager</MenuItem>
              <MenuItem value="trainer">Trainer</MenuItem>
                      <MenuItem value="perfectclining">Perfect Cleaning</MenuItem>
              <MenuItem value="supervisor">Supervisor</MenuItem>
              <MenuItem value="pujarinana">Pujari Nana</MenuItem>
            </Select>
          </FormControl>
                </Grid>
                <Grid size={{ xs: 12,sm:6}}>
            <TextField
                    fullWidth
              label="Salary/Month"
              type="number"
              value={editedData.salary}
              onChange={(e) => setEditedData({ ...editedData, salary: e.target.value })}
                    InputProps={{
                      startAdornment: <Typography sx={{ color: themeColors.textSecondary, mr: 1 }}>₹</Typography>
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: themeColors.background,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12,sm:6}}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
                      label="Joining Date"
                        value={editedData.joiningdate}
                        onChange={(date) => setEditedData({ ...editedData, joiningdate: date })}  
            format="DD/MM/YYYY"
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: {
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              backgroundColor: themeColors.background,
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: themeColors.primary
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: themeColors.primary
                              }
                            }
                          }
                        }
                      }}
                    />
        </LocalizationProvider>
                </Grid>
                <Grid size={{ xs: 12,sm:6}}>
            <TextField
                    fullWidth
              label="Card number"
              type="number"
              value={editedData.card_number}
              onChange={(e) => setEditedData({ ...editedData, card_number: e.target.value })}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: themeColors.background,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        }
                      }
                    }}
                  />
                </Grid>
                {/* SLOT EDIT — comment out after use */}
                <Grid size={{ xs: 12, sm: 4 }}>
                  <TextField
                    fullWidth
                    label="Morning Slot (e.g. 06:00-10:00)"
                    value={editedData.morningSlot || ''}
                    onChange={(e) => setEditedData({ ...editedData, morningSlot: e.target.value })}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px', backgroundColor: themeColors.background, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary } } }}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                  <TextField
                    fullWidth
                    label="Evening Slot (e.g. 16:00-20:00)"
                    value={editedData.eveningSlot || ''}
                    onChange={(e) => setEditedData({ ...editedData, eveningSlot: e.target.value })}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px', backgroundColor: themeColors.background, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary } } }}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                  <TextField
                    fullWidth
                    label="Excuse Time (mins)"
                    type="number"
                    value={editedData.excuseTime || ''}
                    onChange={(e) => setEditedData({ ...editedData, excuseTime: e.target.value })}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px', backgroundColor: themeColors.background, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary } } }}
                  />
                </Grid>
                {/* END SLOT EDIT */}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ 
          borderTop: `1px solid ${themeColors.border}`,
          px: 3,
          py: 2,
          gap: 1
        }}>
          <Button
            onClick={() => setBioOpen(true)}
            variant="outlined"
          >
            Machine biometrics
          </Button>
          <Button 
            onClick={handleEditModalClose}
            startIcon={<CancelIcon />}
            sx={{ 
              color: themeColors.textSecondary,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleEditSubmit}
            variant="contained"
            startIcon={<CheckCircleIcon />}
            sx={{ 
              backgroundColor: themeColors.primary,
              '&:hover': {
                backgroundColor: themeColors.primaryLight
              }
            }}
          >
            Update Employee
          </Button>
        </DialogActions>
      </Dialog>
      <DeviceEnrollDialog
        open={bioOpen}
        token={(() => { try { return JSON.parse(localStorage.getItem("userdata")).token; } catch (e) { return ""; } })()}
        personType="employee"
        personId={editedData.id}
        personName={editedData.fullname}
        onClose={() => setBioOpen(false)}
      />
    </Box>



  );
}

export default EmployeesDetail;